import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X, User, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useCustomer } from "@/context/CustomerContext";
import { useState } from "react";

const Header = () => {
  const { getCartCount } = useCart();
  const { customer, isLoggedIn } = useCustomer();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const cartCount = getCartCount();

  return (
    <header className="sticky top-0 z-50 bg-black border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_pregiato-pwa/artifacts/nccyaily_LOGO.png"
              alt="PREGIATO"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link
              to="/catalogo"
              className="text-white hover:text-green-400 transition-colors font-medium"
              data-testid="nav-catalog-link"
            >
              Catalogo
            </Link>
            
            {/* Profile/Login Link */}
            <Link
              to={isLoggedIn ? "/profilo" : "/accedi"}
              className="flex items-center gap-2 text-white hover:text-green-400 transition-colors font-medium"
              data-testid="nav-profile-link"
            >
              <User className="w-5 h-5" />
              {isLoggedIn ? (
                <span className="flex items-center gap-1">
                  {customer?.account_type === "business" 
                    ? customer?.business_data?.company_name || customer?.name?.split(" ")[0]
                    : customer?.name?.split(" ")[0]
                  }
                  {customer?.account_type !== "business" && !customer?.is_special_customer && (
                    <span className="bg-green-500 text-black text-xs font-bold px-2 py-0.5 rounded-full">
                      {customer?.points || 0} pt
                    </span>
                  )}
                </span>
              ) : (
                "Accedi"
              )}
            </Link>
            
            {isLoggedIn && customer?.is_special_customer && (
              <Link to="/la-mia-lista" className="flex items-center gap-1 text-yellow-500 hover:text-yellow-400 transition-colors font-medium text-sm" data-testid="nav-special-list">
                <ShoppingBag className="w-4 h-4" />
                La Mia Lista
              </Link>
            )}
            
            {!(isLoggedIn && customer?.is_special_customer) && (
            <button
              onClick={() => navigate("/carrello")}
              className="relative p-2 hover:bg-zinc-900 rounded-lg transition-colors"
              data-testid="cart-button"
            >
              <ShoppingCart className="w-6 h-6 text-white" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-green-500 text-black text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center"
                  data-testid="cart-count">
                  {cartCount}
                </span>
              )}
            </button>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-3">
            {!(isLoggedIn && customer?.is_special_customer) && (
            <button
              onClick={() => navigate("/carrello")}
              className="relative p-2"
              data-testid="cart-button-mobile"
            >
              <ShoppingCart className="w-6 h-6 text-white" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-green-500 text-black text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center"
                  data-testid="cart-count-mobile">
                  {cartCount}
                </span>
              )}
            </button>
            )}
            {isLoggedIn && customer?.is_special_customer && (
              <button onClick={() => navigate("/la-mia-lista")} className="p-2">
                <ShoppingBag className="w-6 h-6 text-yellow-500" />
              </button>
            )}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2"
              data-testid="mobile-menu-button"
            >
              {mobileMenuOpen ? (
                <X className="w-6 h-6 text-white" />
              ) : (
                <Menu className="w-6 h-6 text-white" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-zinc-800 pt-4" data-testid="mobile-menu">
            <Link
              to="/catalogo"
              className="block py-2 text-white hover:text-green-400 transition-colors font-medium"
              onClick={() => setMobileMenuOpen(false)}
              data-testid="mobile-nav-catalog-link"
            >
              Catalogo
            </Link>
            <Link
              to={isLoggedIn ? "/profilo" : "/accedi"}
              className="flex items-center gap-2 py-2 text-white hover:text-green-400 transition-colors font-medium"
              onClick={() => setMobileMenuOpen(false)}
              data-testid="mobile-nav-profile-link"
            >
              <User className="w-5 h-5" />
              {isLoggedIn ? (
                <span className="flex items-center gap-2">
                  {customer?.account_type === "business" 
                    ? customer?.business_data?.company_name || customer?.name?.split(" ")[0]
                    : customer?.name?.split(" ")[0]
                  }
                  {customer?.account_type !== "business" && !customer?.is_special_customer && (
                    <span className="bg-green-500 text-black text-xs font-bold px-2 py-0.5 rounded-full">
                      {customer?.points || 0} pt
                    </span>
                  )}
                </span>
              ) : (
                "Accedi / Registrati"
              )}
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
